// src/pages/History/AncientHistory/HistoryPageIndia.js
import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/Classical_Antiquity_-_Maurya_and_Gupta_Empires_India.png';

export default function HistoryPageIndia() {
  return (
    <TopicPage
      topicKey="Maurya and Gupta Empires (India)"
      title="History: Maurya and Gupta Empires"
      backgroundImage={bg}
      startRoute="/History-Maurya-Gupta-Go"
      scrollLabels={[
        "Maurya Dynasty & Ashoka",
        "Gupta Golden Age",
        "Science, Art, and Religion",
      ]}
        backRoute="/history-Classical-Antiquity"   // go back to the Middle-Ages menu
  backLabel="← Return to topics"
  backButtonClassName="journey-button special"
  backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}
